const getNumericalRating = (rating: number): number => {
  // return the number, rounded up to the nearest 0.1 decimal place
  return Math.ceil(rating * 10) / 10;
};

const getStarRating = (rating: number): number => {
  // return the number, rounded up to the nearest 0.5 decimal place
  return Math.ceil(rating * 2) / 2;
};

type Rating = {
  numericalRating: number;
  starRating: number;
};

export const getReviewRatings = (rating: number): Rating => {
  return {
    numericalRating: getNumericalRating(rating),
    starRating: getStarRating(rating),
  };
};
